module.exports = __webpack_public_path__ + "img/electronic_electric_no_zone_selected.9254dbe4.svg";